import React from 'react';
import { personalInfo } from '../../data/personal';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-ink-850/70">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="spotlight inline-block text-3xl sm:text-4xl md:text-5xl font-bold mb-6 pb-2 leading-tight bg-gradient-to-r from-emerald-400 to-gold-400 bg-clip-text text-transparent animate-fade-in-up">
            About Me
          </h2>
          <p className="text-lg sm:text-xl text-slate-300 max-w-3xl mx-auto animate-fade-in-up" style={{animationDelay: '0.2s'}}>
            Software Engineering graduate passionate about building scalable
            full-stack solutions that make a real impact
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start lg:items-center">
          <div className="space-y-6 animate-fade-in-up">
            <div className="lit-card p-5 sm:p-6 rounded-2xl transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-emerald-400 drop-shadow-[0_0_12px_rgba(16,185,129,0.35)]">
                {personalInfo.about.professionalJourney.title}
              </h3>
              <p className="text-slate-300 leading-relaxed text-sm sm:text-base">
                <strong>
                  {personalInfo.subtitle}
                </strong>{" "}
                {personalInfo.about.professionalJourney.description}
              </p>
            </div>

            <div className="lit-card lit-card-gold p-5 sm:p-6 rounded-2xl transition-all duration-300 hover:-translate-y-1">
              <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-gold-400 drop-shadow-[0_0_12px_rgba(212,175,55,0.35)]">
                {personalInfo.about.leadershipImpact.title}
              </h3>
              <p className="text-slate-300 leading-relaxed text-sm sm:text-base">
                {personalInfo.about.leadershipImpact.description}
              </p>
            </div>
          </div>

          <div className="lit-card rounded-2xl p-6 sm:p-8 transition-all duration-300 hover:-translate-y-1 animate-fade-in-up">
            <h3 className="text-xl sm:text-2xl font-semibold mb-6 text-center">
              Core Expertise
            </h3>
            <div className="space-y-4">
              {personalInfo.coreExpertise.map((item, index) => (
                <div key={index} className="flex items-center space-x-3 transform hover:translate-x-2 transition-transform duration-200 cursor-pointer">
                  <div className="w-2 h-2 bg-gradient-to-r from-emerald-400 to-gold-400 rounded-full animate-pulse"></div>
                  <span className="text-slate-300 text-sm sm:text-base">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;